import { c, g as f, i as h } from "../../chunks/create-location-link.CWUHCgFz.js";
const i = (e) => {
  const t = e.asPath.split(/[?#]/)[0];
  return t ? ((o) => o !== "/" && o.endsWith("/") ? o.slice(0, -1) : o)(t) : "/";
}, r = (e, t, n) => {
  n ? t.push(e) : typeof window < "u" ? window.location.href = e : console.warn("Cannot navigate to URL on server side without routing:", e);
};
export {
  c as createLocationLink,
  f as getLinkHref,
  i as getPathFromRouter,
  h as isExternalLink,
  r as routeOrNavigate
};
